function AccordionAnchors() {
  function openAccordion() {
    const currentUrl = document.URL;
    const urlAnchor = currentUrl.split('#');
    const urlID = (urlAnchor.length > 1) ? urlAnchor[1] : null;

    const accordionContent = document.querySelectorAll('.accordion-processed .accordion-content');
    const dtabs = document.querySelectorAll('.accordion-processed .dtabs .tab');
    const underTabs = document.querySelectorAll('.accordion-processed .under-tab');

    if (accordionContent) {
      accordionContent.forEach((content) => {
        if (content.getAttribute('aria-labelledby') === urlID) {
          const parentLabel = content.parentElement.getAttribute('aria-labelledby');
          dtabs.forEach((e) => {
            if (e.id === parentLabel) {
              e.classList.add('active');
              e.setAttribute('aria-selected', true);

              underTabs.forEach((u) => {
                const underTab = u.getAttribute('aria-labelledby');
                if (underTab === e.id) {
                  u.style.display = 'block';
                } else {
                  u.style.display = 'none';
                }
              });
            } else {
              e.classList.remove('active');
              e.setAttribute('aria-selected', false);
            }
          });

          const accordionHeading = content.previousSibling;
          accordionHeading.classList.add('active');
          accordionHeading.querySelector(`#${urlID}`).setAttribute('aria-expanded', 'true');
          setTimeout(() => {
            content.style.display = 'block';
            accordionHeading.scrollIntoView();
          }, 500);
        } else {
          const accordionHeading = content.previousSibling;
          accordionHeading.classList.remove('active');
          accordionHeading.querySelector('a').setAttribute('aria-expanded', 'false');
          setTimeout(() => {
            content.style.display = 'none';
          }, 500);
        }
      });
    }
  }
  openAccordion();

  window.addEventListener('hashchange', () => {
    openAccordion();
  });
}

export default AccordionAnchors;
